import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../app.reducer';
import { Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { MatDialog } from '@angular/material/dialog';
import { TerminosComponent } from './terminos/terminos.component';

@Component({
    selector: 'app-settings',
    templateUrl: './settings.component.html',
    styleUrls: ['./settings.component.scss'],
    standalone: false
})
export class SettingsComponent implements OnInit {

  userSubscription: Subscription = new Subscription();
  name = "";
  userImg= "";
  img="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcRlWkkJDRgqwZriGSI4R0ntWMI9Scm31zIQGYJo5ZpeDHSC4MW3"
  title = "Editar perfil";
  user = { 
    id: 0,
    first_name: "",
    last_name: "",
    photo_media_id:{ url: ""},
    email: "",
    email_verified_at: "",
    role_id: 0,
    profile_image: "",
    country: "",
    state: "",
    city: "",
    st_address: "",
    zip: "",
    country_code: "",
    phone_0: "",
    date_of_birth: "",
    gender: "",
    device_token: "",
    fcm_id: "",
    push_notification: "",
    time_zone: "",
    account_status: 0,
    account_delete: 0,
    registration_step: 0,
    session_id: "",
    token: "",
    status: 0,
    deleted_at: "",
    created_at: "",
    updated_at: "",
    country_code_flag: "",
    total_social: 0,
    profile_image_url: "",
    created_atz: "",
    enckey: "",
    doctor: "",
  };

  constructor( private store:Store<AppState>, private service: AuthService, public dialog: MatDialog ) { 
    let user = this.service.user;

    this.user = this.service.user;

    this.userImg = this.user.photo_media_id ? this.user.photo_media_id.url : "https://via.placeholder.com/300.png/7D2716/fff" ;
  }

  ngOnInit() {
  }

  changeTitle(title){
    this.title = title;
  }

  openTerms(){
    console.log('Opening terms')
    const dialogRef = this.dialog.open(TerminosComponent, {
      width: '1000px',
      height: '780px',
      data: { data: 'filtros' }
    });
  }
}
